/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

const tabBlocks = document.querySelectorAll( '.wp-block-create-block-docomo-tab' );

tabBlocks.forEach( ( tabBlock ) => {
	const tabList = tabBlock.querySelector( '.docomo-tab-list' );
	const contentWrapper = tabBlock.querySelector( '.content-wrapper' );
	const tabPanels = Array.from( contentWrapper?.children || [] ).filter( ( element ) =>
		element.classList.contains( 'docomo-tab-panel' )
	);
	const isRoundedShape = tabList?.classList.contains( 'is-shape-rounded' );
	if ( ! tabList || ! tabPanels.length ) {
		return;
	}

	tabList.innerHTML = '';

	tabPanels.forEach( ( panel, index ) => {
		const tabId = `docomo-tab-panel-${ index }`;
		panel.setAttribute( 'data-id', tabId );
		panel.classList.toggle( 'is-active', index === 0 );

		const title = panel.getAttribute( 'data-tab-title' ) || `Tab ${ index + 1 }`;
		const icon = decodeURIComponent( panel.getAttribute( 'data-tab-icon' ) || '' );
		const titleAlignment = panel.getAttribute( 'data-tab-title-align' ) || 'left';
		const effectiveTitleAlignment = isRoundedShape ? 'center' : titleAlignment;

		const item = document.createElement( 'li' );
		const link = document.createElement( 'a' );
		link.setAttribute( 'href', '#' );
		link.setAttribute( 'role', 'tab' );
		link.className = `docomo-tab-link ${ index === 0 ? 'is-active' : '' } ${
			isRoundedShape ? 'is-rounded-full' : ''
		}`;
		link.setAttribute( 'data-target', tabId );
		link.innerHTML = `<span class="docomo-tab-icon">${ icon }</span><span class="docomo-tab-title docomo-tab-title-align-${ effectiveTitleAlignment }">${ title }</span>`;
		item.appendChild( link );
		tabList.appendChild( item );
	} );

	tabList.addEventListener( 'click', ( event ) => {
		const tabLink = event.target.closest( '.docomo-tab-link[data-target]' );
		if ( ! tabLink ) {
			return;
		}
		event.preventDefault();
		const targetId = tabLink.getAttribute( 'data-target' );
		const links = tabList.querySelectorAll( '.docomo-tab-link[data-target]' );
		links.forEach( ( item ) => item.classList.remove( 'is-active' ) );
		tabPanels.forEach( ( panel ) => panel.classList.remove( 'is-active' ) );
		tabLink.classList.add( 'is-active' );
		const activePanel = tabPanels.find(
			( panel ) => panel.getAttribute( 'data-id' ) === targetId
		);
		if ( activePanel ) {
			activePanel.classList.add( 'is-active' );
		}
	} );
} );
